document.addEventListener("DOMContentLoaded", function() {
  var headingLinks = document.querySelectorAll(".heading-container a");
  var faqItems = document.querySelectorAll('.faq-item');
  // headingLinks[0].classList.add('active');

  function showTarget(targetId) {
    var targetDiv = document.querySelector(targetId);
    if (targetDiv) {
      var contentContainers = document.querySelectorAll(".content-container .container-box");
      contentContainers.forEach(function(container) {
        container.style.display = "none";
        container.classList.remove('active');
      });

      targetDiv.style.display = "block";
      targetDiv.classList.add('active');

      headingLinks.forEach(function(link) {
        link.classList.remove('active');
      });

      var targetLink = document.querySelector('[data-target="' + targetId + '"]');
      if (targetLink) {
        targetLink.classList.add('active');
      }
    }
  }

  const headingLinksNew = document.querySelectorAll(".heading-link");
  if (headingLinksNew.length > 0) {
      showTarget(headingLinksNew[0].getAttribute("data-target"));
  }
  

  headingLinks.forEach(function(link) {
    link.addEventListener("click", function(event) {
      var targetId = this.getAttribute("data-target");
      showTarget(targetId);
    });
  });

  faqItems.forEach(item => {
    var question = item.querySelector('.faq-question');
    var answer = item.querySelector('.faq-answer');
    var toggle = item.querySelector('.faq-toggle');

    question.addEventListener('click', (event) => {
      event.stopPropagation();
      event.preventDefault();

      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove('active');
        }
      });

      item.classList.toggle('active');
    });
  });
});
